import './VictoryAnimation.scss';
import PlayerHelper from '../../players/PlayerHelper';
import React, {useEffect, useState} from 'react';
import {Transition} from 'react-transition-group';
import {GameResult} from "../../common-build/stuff/BaseGameState";

const MAX_DELAY_MS = 1000;


const defaultStyle = {
  opacity: 0,
}
const transitionStyles = {
  entering: {},
  entered: { opacity: 1 , transform: 'scale(0)' }, // Before
  exiting: { opacity: 0, transform: 'scale(1)' }, // During
  exited: {},
};
const animationParams = {
  MAX_X_PX: 500,
  MAX_Y_PX: 500,
};
const makeAnimatedItemFromText = (playerStyleClass, text) =>
    makeAnimatedItemFromElement(playerStyleClass, <div>{text}</div>);

interface AnimatedItem {
    playerStyleClass: string | null;
    el: any;
    delayMs: number;
    styles: any;
    in: boolean;
    unmountOnExit?: boolean;
}

const makeAnimatedItemFromElement = (playerStyleClass, el): AnimatedItem => ({
  playerStyleClass,
  el,
  delayMs: Math.random() * MAX_DELAY_MS,
  styles: {exiting: makeRandomTransformStyle()},
  in: true,
});
const makeRandomTransformStyle = () => {
  let tx = animationParams.MAX_X_PX * (Math.random() * 2 - 1);
  let ty = animationParams.MAX_Y_PX * (Math.random() * 2 - 1);
  return { transform: `scale(5) translate(${tx}px, ${ty}px)` };
};


const TransitionItem = props => {
  let item = props.item;
  let ref = React.useRef<HTMLDivElement>(null);
  return (
    <Transition
        in={item.in} timeout={1000}
        nodeRef={ref}
        mountOnEnter={true} unmountOnExit={item.unmountOnExit}>
      {state => (
        <div
            className={`animatedItem ${item.playerStyleClass}`}
            ref={ref}
            style={{
                ...defaultStyle,
                ...transitionStyles[state],
                ...item.styles[state]}}>
          {item.el}
        </div>
      )}
    </Transition>
  );
};


const OutcomeEl = props => {
  let players = props.players;
  if (players.length === 1) {
    return (
      <div className='outcome'>
        <div className='icon'>
          <img
              src={
                  PlayerHelper.getAvatar(
                      players[0], PlayerHelper.AvatarType.VICTORY)}
              alt='avatar' />
        </div>
        <div className='label'>winner!</div>
      </div>
    );
  }

  if (players.length === 0) {
    return null;
  }

  return (
    <div className='outcome'>
      <div className='label'>draw!</div>
    </div>
  );
};


interface VictoryAnimationProps {
    gameEnd: GameResult;
    players: any[];
}

/**
 * props:
 *   gameEnd: Object
 *   players: Array
 */
const VictoryAnimation = (props: VictoryAnimationProps) => {

  const [animatedItems, setAnimatedItems] = useState<AnimatedItem[]>([]);
  const [isDismissed, setIsDismissed] = useState(false);

  const propStr = JSON.stringify({
    gameEnd: props.gameEnd,
    players: props.players,
  })

  useEffect(() => { // Create animated items
    const isWin = props.gameEnd && 'win' in props.gameEnd;
    const isDraw = props.gameEnd && 'draw' in props.gameEnd;

    if (!isWin && !isDraw) {
      return;
    }
    let players = isWin ?
        [props.players[props.gameEnd['win']]] :
        [...props.players];
    let victoryPlayerStyles = players.map(PlayerHelper.getStyleClass);
    let outcomeItem: AnimatedItem = {
      playerStyleClass: isWin ? victoryPlayerStyles[0] : null,
      el: <OutcomeEl players={players} />,
      delayMs: MAX_DELAY_MS,
      styles: {exiting: {opacity: 1}, exited: {opacity: 1}},
      in: true,
      unmountOnExit: false,
    };
    let items = [
      ...Array(80).fill(null).map((_, i) =>
        makeAnimatedItemFromText(
            victoryPlayerStyles[i % victoryPlayerStyles.length], i % 10)
      ),
      outcomeItem,
    ];
    setAnimatedItems(items);
    let timers = items.map(item =>
      setTimeout(() => {
        item.in = false;
        setAnimatedItems(items => [...items]);
      }, item.delayMs)
    );
    return () => timers.forEach(clearTimeout);
  }, [propStr]);

  if (isDismissed) {
    return null;
  }

  return (
    <div className='VictoryAnimation' onClick={() => setIsDismissed(true)}>
      {animatedItems.map((item, i) => <TransitionItem key={i} item={item} />)}
    </div>
  );
};


export default VictoryAnimation;
